import { Component, OnDestroy, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import { environment as ENV } from '../../../environments/environment';
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import {bankDetailsProp, categoryProps, IResponse} from "../../interfaces/iresponse";
import {UserService} from "../../services/apiCalls/userService/user.service";
import {BootstrapNotifyService} from "../../services/bootstrap-notify/bootstrap-notify.service";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { genderType } from 'src/app/users/enrol-riders/enrol-riders.component';

@Component({
  selector: 'app-manage-zones',
  templateUrl: './manage-zones.component.html',
  styleUrls: ['./manage-zones.component.css']
})
export class ManageZonesComponent implements OnInit, OnDestroy {
  breadCrumb: any;
  disabled:boolean = false;
  currentZoneId: number = 0;
  banks: bankDetailsProp[] = [];
  filterZoneBy: genderType[] = [
    {id: 1, value: '', name: 'Filter Zone By Status'},
    {id: 1, value: '1', name: 'All'},
    {id: 1, value: 'active', name: 'Active'},
    {id: 1, value: 'inactive', name: 'InActive'},
  ];
  filterForm = new FormGroup({
    status: new FormControl('', Validators.required)
  })
  accountName: string = '';
  loadingAccountName: boolean = false;
  sub!:Subscription;
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  loaders = {
    saving: false
  };
  allStates: any [] = [];
  categories: Array<categoryProps> = [];
  public activeZone: number = 0;
  public zones: any[] = [];
  public loadingData = false;
  public modal = {
    title: 'Create Zonal Area',
    btnText: 'SAVE'
  };
  showData: boolean = true;
  currentModal : string = 'create';
  constructor(private utilService: UtilService,
              private alertService: BootstrapNotifyService,
              private superAdminService: SuperAdminService,
              private userService: UserService) {
              this.getStates();
  }

  zoneForm = new FormGroup({
    name: new FormControl('', Validators.required),
    state_id: new FormControl('', Validators.required),
    category_id: new FormControl('', Validators.required),
    settlement_bank_code: new FormControl('', Validators.required),
    settlement_account_name: new FormControl('', Validators.required),
    settlement_account_number: new FormControl('', [Validators.pattern('^[0-9]{10}'), Validators.maxLength(10)])
  })

  validateAccountNumber(){
    const control = this.zoneForm.get('settlement_account_number');
    if(control.hasError('pattern') || control?.value?.length > 10 ){
      return true;
    }
    return false;
  }



  ngOnInit() {
    this.breadCrumb  = {
      name: 'Manage Zones',
      parent: 'Settings',
      subLink: null
    };
    this.getAllZones();
    this.getCategories();
    this.getBanks();

    this.filterForm.get('status').valueChanges.subscribe(() => {
      this.getAllZones();
    })

    this.sub = this.zoneForm.get('settlement_account_number').valueChanges.subscribe((value: string)=>{
        const code = this.zoneForm.get('settlement_bank_code').value;
        if(!code || value.length !== 10){
          this.accountName = '';
          return;
        }else{
          const payload = {
            account_number: String(value),
            bank_code: code
          }
          this.getAccountNumber(payload);
          return;
        }
      })
    this.sub = this.zoneForm.get('settlement_bank_code').valueChanges.subscribe((value: string)=>{
        const accountNumber = this.zoneForm.get('settlement_account_number').value;
        if(!value || accountNumber.length !== 10){
          this.accountName = '';
          return;
        }else{
          const payload = {
            account_number: String(accountNumber),
            bank_code: value
          }
          this.getAccountNumber(payload);
          return;
        }
      })
  }

  disableZoneArea():boolean{
    if(
      this.getFormControlValue('name') && 
      this.getFormControlValue('state_id') && 
      this.getFormControlValue('category_id')) return false;
    return true;
  }

  getAccountNumber(payload:{account_number: string, bank_code: string}){
    this.loadingAccountName = true;
    this.superAdminService.postSettlementAccount(payload).subscribe({
      next: (response)=>{
        this.accountName = response.account_name;
        this.zoneForm.setControl('settlement_account_name', new FormControl(this.accountName));
      },
      error: (err)=>{
        this.alertService.error(err.error.message)
      }
    }).add(()=> this.loadingAccountName = false)
  }

  getFormControlValue(control: string){
    const formControl = this.zoneForm.get(control).value;
    return formControl;
  }

  getBanks(){
    return this.userService.getBanks().subscribe({
      next: (response)=>{
        this.banks = response;
      },
      error: (err)=>{

      }
    })
  }
  saveZone() {
    this.loaders.saving = true;
    if(this.currentModal === 'edit') {
      this.updateZone();
    } else {
      if(this.getFormControlValue('settlement_bank_code') === '' && this.getFormControlValue('settlement_account_number') === ''){
        const payload = {
          name: this.getFormControlValue('name'),
          state_id: this.getFormControlValue('state_id'),
          category_id: this.getFormControlValue('category_id'),
        }
        for(let [key, value] of Object.entries(payload)){
          if(value === '' || value?.length === 0){
            return;
          }
        }
            this.superAdminService.createZone(payload).subscribe((res) => {
              this.getAllZones();
              this.zoneForm.reset();
              this.loaders.saving = false;
              this.utilService.closeModal('zoneModal');
              this.alertService.success(res.message || 'Zone created successfully!', 'right');
            }, error => {
              this.alertService.error(error.error.message || 'Unable to create zone!');
              this.loaders.saving = false;
            });
      }else{
        if(this.zoneForm.valid) {
          const payload = {...this.zoneForm.value, verify_settlement_account: true, settlement_account_name: this.accountName};
          this.superAdminService.createZone(payload).subscribe((res) => {
            this.getAllZones();
            this.zoneForm.reset();
            this.loaders.saving = false;
            this.utilService.closeModal('zoneModal');
            this.alertService.success(res.message || 'Zone created successfully!', 'right');
          }, error => {
            this.alertService.error(error.error.message || 'Unable to create zone!');
            this.loaders.saving = false;
          });
        } else {
          this.alertService.error('Unable to create zone!');
          this.loaders.saving = false;
        }
      }
    }

  }

  openDialog(id: string, mode: 'create' | 'edit' = 'create', zone?: any) {
  // Always clear previous form values first
  this.zoneForm.reset({
    name: '',
    category_id: '',
    state_id: '',
    settlement_account_name: '',
    settlement_account_number: '',
    settlement_bank_code: ''
  });

  this.accountName = '';
  this.activeZone = 0;

  if (mode === 'edit' && zone) {
    this.currentModal = 'edit';

    this.modal = {
      title: 'Update Zonal Area',
      btnText: 'UPDATE'
    };

    this.activeZone = zone.id;

    const {
      name,
      state_id,
      category_streams
    } = zone;

    const categoryStream = category_streams?.[0];

    this.accountName = categoryStream?.settlement_account_name || '';

    this.zoneForm.patchValue({
      name: name || '',
      state_id: state_id || '',
      category_id: categoryStream?.category_id || '',
      settlement_bank_code: categoryStream?.settlement_bank_code || '',
      settlement_account_number: categoryStream?.settlement_account_number || '',
      settlement_account_name: this.accountName
    });
  } else {
    this.currentModal = 'create';

    this.modal = {
      title: 'Create Zonal Area',
      btnText: 'SAVE'
    };
  }

  this.utilService.openModal(id);
}


  getCategories(){
    return this.userService.getCategories('').subscribe({
      next: (res)=>{
        this.categories = res.filter(f=> f.status.toLowerCase() === 'active');
      }
    })
  }
  getAllZones() {
    this.showData = false;
    this.loadingData = true;
    const filter = this.filterForm.get('status').value;
    this.userService.getAllZones(filter)
      .subscribe((res: IResponse) => {
        this.zones = res.data;
        this.utilService.startDatatable('all-state-zones');
        this.loadingData = false;
        this.showData = true;
      }, error => {
        this.utilService.startDatatable('all-state-zones');
        this.alertService.error(error.error.message)
        this.loadingData = false;
        this.showData = true;
      });
  }

  public triggerEdit(zone: any){
    this.openDialog('zoneModal', 'edit', zone);
    this.modal = {
      title: 'Update Zonal Area',
      btnText: 'UPDATE'
    };
    this.currentModal = 'edit';
    this.activeZone = zone.id;
    const {name, state_id, category_streams} = zone;
    const{category_id, settlement_bank_code, settlement_account_number, settlement_account_name} = category_streams[0];
    this.accountName = settlement_account_name || '';
    const bankCode = settlement_bank_code || '';
    const accountNumber = settlement_account_number || '';
    this.zoneForm.patchValue({name, state_id, category_id, settlement_account_number: accountNumber, settlement_bank_code: bankCode, settlement_account_name: this.accountName});
  }
  public getStates() {
    this.userService.getAllState().subscribe(res => {
      this.allStates = res.data;
    }, error => {
    })
  }

  public toggleZoneStatus(zone) {
    this.disabled = true;
    this.currentZoneId = zone.id;

    const action = zone.status === 'Active' ? 'disable' : 'enable';

    this.utilService.confirmAction(() => {
      this.superAdminService.toggleZoneStatus(zone.id, action).subscribe((res: IResponse) => {
        this.filterForm.get('status').setValue('', { emitEvent: false });
        this.getAllZones();
        this.alertService.success(res.message || `Zone ${action}d successfully!`, 'right');
      }, error => {
        this.alertService.error(error.error.message);
      }).add(() => this.disabled = false);
    }, () => {
      this.disabled = false;
      this.currentZoneId = 0;
    });
  }

  public deleteZone(zone) {
    this.disabled = true;
    this.currentZoneId = zone.id;
    this.utilService.confirmAction(() => {
      this.superAdminService.deleteZone(zone.id)
        .subscribe((res: IResponse) => {
          this.getAllZones();
          this.alertService.success(res.message);
        }, error => {
          this.alertService.error(error.error.message);
        });
    }, ()=>{
      this.disabled = false;
      this.currentZoneId = 0;
    })
  }
  public updateZone() {
    if(this.zoneForm.valid) {
      const payload = {...this.zoneForm.value, verify_settlement_account: true};
      this.superAdminService.updateZone(payload, this.activeZone).subscribe((res) => {
      this.getAllZones();
      this.utilService.closeModal('zoneModal');
      this.loaders.saving = false;
      this.alertService.success(res.message || 'Zone updated successfully!', 'right');

    }, error => {
      this.alertService.error(error.error.message || 'Unable to update zone!');
      this.loaders.saving = false;

    });
  } else {
    this.alertService.error('Unable to update zone!');
      this.loaders.saving = false;
    }
}

  // onFilterBy(){
  //   if(this.filterForm.invalid) return;
  //   this.getAllZones();
  // }

ngOnDestroy(): void {
  this.sub.unsubscribe();
}
}
